import React from 'react';
import ExpenseTable from '../components/ExpenseTable/ExpenseTable';

const ExpensesPage: React.FC = () => {
  return <ExpenseTable />;
};

export default ExpensesPage;
